import styled from 'styled-components';

export const LoginModalComponentContainer = styled.div`
    padding: 40px;

    .log-in {
        margin-top: 40px;
    }

    p {
        margin-bottom: 10px;
    }

    .register-link {
        .fakelink {
            margin-left: 0.5rem;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginModalComponentStyle.js